import CMSActions from '../Components/CMS/CMSActions'

function createAndGetFormDataObject(data, images) {
  const formData = new FormData()

  formData.append('request', JSON.stringify(data))

  images.forEach((image) => {
    if (image.file === undefined) return
    formData.append('images', image.file, image.originalName)
    image.file = null
  })

  return formData
}

async function saveSectionVideoProcess(data, videos, images) {
  //start saving
  const jsonData = await createAndGetFormDataObject(data, images)
  const sectionVideoProcessResponse = await CMSActions.saveSectionVideoProcess(jsonData)

  if (!sectionVideoProcessResponse) return { sectionVideoProcessResponse }

  let encoderResponse = null

  //encoding method
  const results = await Promise.all(
    videos.map(async (v) => {
      const payload = {
        sectionVideoId: sectionVideoProcessResponse._id,
        originalName: v.originalName,
        caption: v.caption,
        fullusername: data.iarMemberFullName,
        secondsDuration: v.secondsDuration,
        fireDepartmentId: data.fireDepartmentId,
        timezone: data.timezone,
        size: v.size
      }

      // Getting Encoder Response
      encoderResponse = await CMSActions.sendToEncoderVideo(data.identifier, v, payload)

      // Gathering encoder errors
      return {
        originalName: v.originalName,
        success: Boolean(encoderResponse)
      }
    })
  )
  
  const encoderErrors = results.filter(x => !x.success)
    .map(x => x.originalName)

  return {
    encoderResponse: encoderResponse,
    sectionVideoProcessResponse: sectionVideoProcessResponse,
    encoderErrors: encoderErrors
  }
}

export { saveSectionVideoProcess }
